/* eslint "react/display-name": "warn" */

export default props =>
  <p className='value-disclosure'>
   Estimated Values are calculated by a computer analysis of the market around the subject property. There are many factors that can affect a property valuation and our calculations cannot account for all of them. The calculation assumes that the property will be remodeled to meet the highest standards in the neighborhood and therefore does not reflect an as-is value. Do not use this value to make financial or investment decisions. A more accurate value can be obtained through a certified appraisal.
  </p>
